var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"g-layout"}},[_c('the-header'),_vm._v(" "),_c('notifications',{attrs:{"group":"info","classes":"vue-notification","position":"top center","speed":1000}}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('the-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }